import VERTEX_SHADER from "./shaders/base-overlay.vs";
import FRAGMENT_SHADER from "./shaders/performance/perftest.fs";

class PerfTestMaterial extends THREE.ShaderMaterial {
    constructor(iterationCount) {
        const uniforms = {};
        const defines = { ITERATION_COUNT: iterationCount };

        super({
            uniforms,
            defines,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER
        });
    }
}

export default PerfTestMaterial;
export { PerfTestMaterial };